<ng-material-multilevel-menu [configuration]='config' [items]='menuItems'>
</ng-material-multilevel-menu>